<template>
  <div id="login" class="container">
    <div class="logoBox">
      <img src="@/assets/logo_text.svg" alt="" />
    </div>
    <!-- TITLE//S-->
    <div class="page-title">
      <p>{{ $t("notice.title.passwordReset") }}</p>
    </div>
    <div class="sub-title">
      <p>보안정책으로 비밀번호 변경 시 24시간 동안 모든 출금이 제한됩니다.</p>
    </div>
    <!-- TITLE//E-->

    <!-- 비밀번호 -->
    <div class="password">
      <div class="title mb5">비밀번호</div>
      <el-input
        v-model="password"
        :disabled="disabledInput"
        placeholder="8~20자, 영문(대/소문자), 숫자, 특수문자 조합 필수"
        class="text-style"
        @input="validPassword"
        show-password
      />
    </div>
    <!-- 비밀번호 확인 -->
    <div class="checklist">
      <div class="list" :class="{ checked: check.English }">
        영문 대/소문자 포함
      </div>
      <div class="list" :class="{ checked: check.Number }">숫자포함</div>
      <div class="list" :class="{ checked: check.Length }">8자 이상</div>
      <div class="list mb4" :class="{ checked: check.SpecialCharacter }">
        특수문자 포함
      </div>
      <div class="specialCharacter-box">
        <p>
          {{ `. , ‘ / ~ ! @ # $ % ^ & * ( ) - _ = + [ ] { } | ; : < > / ? ` }}
        </p>
      </div>
    </div>
    <div class="confirm-password">
      <div class="title mb5">비밀번호 확인</div>
      <el-input
        v-model="confirmPassword"
        :disabled="disabledInput"
        placeholder="비밀번호 확인"
        class="text-style"
        @input="checkPassword"
        show-password
      />
    </div>
    <div class="not-password" v-if="wrongPassword">
      비밀번호가 일치하지 않습니다.
    </div>
    <!-- LOGIN FORM//S -->
    <div class="button-wrap mt16">
      <button
        color="danger"
        class="btn-block custom send-email"
        type="filled"
        :disabled="disabledButton"
        @click="savePassword"
      >
        {{ $t("resetPassword.title") }}
      </button>
    </div>
    <!-- LOGIN FORM//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
export default {
  created() {
    if (
      !_.has(this.$route.query, "code") ||
      !_.has(this.$route.query, "email") ||
      !_.has(this.$route.query, "via")
    ) {
      // 코드정보 부족
      this.$router.back();
    }
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      wrongPassword: false, //비밀번호 오입력 시 안내 문구
      disabledInput: false,
      check: {
        English: false,
        Number: false,
        Length: false,
        SpecialCharacter: false,
      },
    };
  },
  computed: {
    disabledButton() {
      if (
        this.password !== "" &&
        this.confirmPassword !== "" &&
        this.check.English == true &&
        this.check.Number == true &&
        this.check.Length == true &&
        this.check.SpecialCharacter == true &&
        this.wrongPassword == false
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    savePassword() {
      if (!this.confirmPassword) {
        this.joinFailNoti(this.$t("signup.error.passValide"));
        return false;
      }
      if (this.password !== this.confirmPassword) {
        this.joinFailNoti(this.$t("signup.error.passNoMatch"));
        return false;
      }
      const { code } = window.routeQuery;
      Api.User.changePassword({
        password: this.password,
        code,
      })
        .then((_res) => {
          this.$vs.notify({
            title: this.$t("resetPassword.title"),
            text: this.$t("resetPassword.passwordResetComplete"),
            type: "warning",
            position: "top-left",
          });
          this.$router.push({ name: "Login" });
        })
        .catch((err) => {
          this.joinFailNoti(err.msg);
        });
    },
    joinFailNoti(text, title = this.$t("resetPassword.title")) {
      this.$vs.notify({
        title: title ? title : "안내",
        text: text
          ? text
          : "문제가 지속적으로 발생 시 고객센터에 문의해 주세요.",
        position: "top-right",
        color: "danger",
      });
    },
    validPassword() {
      // 비밀번호 체크
      const checkonlyEnglish = /[a-zA-Z]/g;
      const checkonlyNumber = /[0-9]/g;
      const checkonlyLength = /^.{8,}$/;
      const checkonlySpecialCharacter = /(\.|\,|\'|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\=|\+|\[|\]|\{|\}|\]|\||\;|\:|\<|\>|\/|\?)/g;

      this.check.English = checkonlyEnglish.test(this.password); //영문만 체크
      this.check.Number = checkonlyNumber.test(this.password); //숫자만 체크
      this.check.Length = checkonlyLength.test(this.password); //길이만 체크
      this.check.SpecialCharacter = checkonlySpecialCharacter.test(
        this.password
      ); //특수문자만 체크

      if (this.password != this.confirmPassword) {
        if (this.confirmPassword == "") {
          return (this.wrongPassword = false);
        }
        this.wrongPassword = true;
      } else {
        this.wrongPassword = false;
      }
      if (this.password == "") {
        //비밀번호 공란일 때
        this.check.English = false;
        this.check.Number = false;
        this.check.Length = false;
        this.check.SpecialCharacter = false;
      }
    },
    checkPassword() {
      if (this.password != this.confirmPassword) {
        this.wrongPassword = true;
      } else {
        this.wrongPassword = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/color_palette.scss";

.logoBox {
  padding-bottom: 24px;
  img {
    width: 100px;
  }
}

.container {
  padding: 12px;
  .page-title {
    font-size: 16px;
    font-weight: bold;
  }
  .password {
    margin-top: 16px;
  }
}
.checklist {
  padding: 10px;
  margin: 8px 0 16px;
  border: solid 1px #dcdfe3;
  border-radius: 2px;
  background-color: #f7f8fa;
  .list {
    position: relative;
    margin-bottom: 12px;
    padding-left: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 14px;
      height: 14px;
      background-image: url("~@/assets/img/common/icon-check-disabled.svg");
      background-repeat: no-repeat;
    }
    &.checked {
      &:after {
        background-image: url("~@/assets/img/common/icon-check-abled.svg");
      }
    }
  }
  .not-password {
    color: red;
  }
  .specialCharacter-box {
    width: fit-content;
    /* height: 24px; */
    margin-left: 20px;
    padding: 0 10px;
    background-color: #dcdfe3;
    p {
      line-height: 24px;
    }
  }
}
</style>
